import { Button } from '@cloudscape-design/components';
import useGetProductById from 'features/products/hooks/useGetProductById';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Renders product fields (e.g. "SKU - name") looked up from a productDocId.
 * Lookups go through the cached useGetProductById query, so repeated cells for
 * the same product share one fetch. Fields missing on the product (or a failed
 * lookup) degrade to whatever is available, or an em dash.
 */
export default function ProductDisplay({
  productDocId,
  fields = ['name'],
  separator = ' - ',
  link = false,
}) {
  const navigate = useNavigate();
  const { data: product, isLoading } = useGetProductById(productDocId);

  if (!productDocId) return '—';
  if (isLoading) return 'Loading...';

  const text = fields.map((field) => product?.[field]).filter(Boolean).join(separator);
  if (!text) return '—';

  if (!link) return text;

  return (
    <Button variant="inline-link" onClick={() => navigate(`/products/${productDocId}`)}>
      {text}
    </Button>
  );
}

ProductDisplay.propTypes = {
  productDocId: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.oneOf(['name', 'sku'])),
  separator: PropTypes.string,
  link: PropTypes.bool,
};
